import { Table } from "react-bootstrap";
import type { SecondarySecuritiesData } from "../lib/explainTypes";

interface Props {
  secondary: SecondarySecuritiesData | null;
}

export default function SubstitutionsSection({ secondary }: Props) {
  if (!secondary || secondary.substitutions.length === 0) {
    return <div className="text-muted">No substitutions.</div>;
  }
  return (
    <Table size="sm">
      <thead>
        <tr>
          <th>Primary</th>
          <th>Secondary</th>
          <th>Treatment</th>
          <th className="text-end">Weight transferred</th>
        </tr>
      </thead>
      <tbody>
        {secondary.substitutions.map((s) => (
          <tr key={`${s.primary}-${s.secondary}`}>
            <td>{s.primary}</td>
            <td>{s.secondary}</td>
            <td>{s.treatment}</td>
            <td className="text-end">{s.weight_transferred}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}
